@use '../@shared/global' as *;

@layer kol-component {
	.kol-image {
		display: inline-block;
		max-width: 100%;
		max-height: 100%;
	}
}
